import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';

import { CONSTANTS } from '../../constants';
import { ChannelService } from '../../services/api/channel.service';
import { DataService } from '../../services/data.service';
import { NotificationService } from '../../services/notification.service';

@Component({
  selector: 'app-channel',
  templateUrl: './channel.component.html',
  styleUrls: ['./channel.component.scss']
})

export class ChannelComponent implements OnInit {

  servers: any = [];
  selServerId: any;
  selServerMode: any = false;

  channels: any = [];
  admin: any;

  public innerWidth: any;

  constructor(private channelService: ChannelService, private dataService: DataService,
    private ns: NotificationService) { }

  ngOnInit(): void {
    this.admin = sessionStorage.getItem(CONSTANTS.COOKIE.IS_ADMIN);
    this.dataService.pageLoaded({name: CONSTANTS.URI_PATH.CHANNEL});
    this.loadServerList();

    this.innerWidth = window.innerWidth;
    if(innerWidth <= 700){
      $("#wrapper").removeClass('toggled');
    }else{
      $("#wrapper").removeClass('toggled');
    }
  }

  ngOnDestroy() { }

  checkNull(key: any, defa: any) {
    if (key && key != null) {
      if (key.toFixed) {
        return Math.abs(key).toFixed(2);
      } else {
        return key
      }
    }
    return defa;
  }

  loadServerList() {
    this.channelService.getServerList().subscribe((response: any) => {
      this.servers = response.server_list;
      this.selServerId = this.servers[0].server_name;
      this.setServerMode();
      this.loadChannelList();
    });
  }

  loadChannelList() {
    let server: any = this.get_selected_server();
    if (!server) {
      // this.notificationService.showAlert('No Server Selected', CONSTANTS.ERROR);
      return;
    }
    this.channelService.getChannelList(server.api_url).subscribe((response: any) => {
      this.channels = response.channel_list;
    });
  }

  channelClass(channel: any) {
    if (channel.channel_status.toLowerCase() == 'connected') {
      return { 'bi-stop-fill': 1, 'text-danger': 1 }
    } else {
      return { 'bi-play-fill': 1, 'text-success': 1 }
    }
  }

  get_selected_server() {
    let sidx = -1;
    for (let idx = 0; idx < this.servers.length; idx++) {
      if (this.servers[idx].server_name == this.selServerId) {
        sidx = idx;
        break;
      }
    }
    if (sidx > -1) {
      return this.servers[sidx];
    }
  }
  onAlert(msg: any, file: any) {
   // this.jq.openModal('notiModal');
    let audio = new Audio(file);
    audio.play().catch((error: any) => {
      this.ns.showAlert(CONSTANTS.ERROR, error)
     });
  }

  onStartStopChannel(channel: any) {
    let server: any = this.get_selected_server();
    if (server) {
      let data: any = { bname: channel.broker_name, action: (channel.channel_status.toLowerCase() == 'connected') ? 'stop' : 'start' };
      this.channelService.startStopChannel(data, server.api_url).subscribe((response: any) => {
        if (response.response_code == 1000) {
          this.ns.showAlert(CONSTANTS.SUCCESS, `Channel ${(data.action == 'start') ? 'Started' : 'Stopped'} successfully`)
        }
      });
    }
  }

  onSwitchChannel(channel: any) {
    let server: any = this.get_selected_server();
    if (server) {
      let data: any = { bname: channel.broker_name };
      this.channelService.switchChannel(data, server.api_url).subscribe((response: any) => {
        if (response.response_code == 1000) {
          this.ns.showAlert(CONSTANTS.SUCCESS, "Channel Switched successfully")
        }
      });
    }
  }

  onSelServer() {
    this.setServerMode();
    this.loadChannelList();
  }

  loadDetails() {
    this.loadServerList();
  }

  setServerMode() {
    this.selServerMode = (this.servers[0].test_mode == 1);
  }

  onTestCheck(event: any) {
    this.selServerMode = event.target.checked;
    let server: any = this.get_selected_server();
    if (server) {
      this.channelService.setServerFeedMode({mode:this.selServerMode ? 1 : 0}, server.api_url).subscribe((response: any) => {
        this.ns.showAlert(CONSTANTS.SUCCESS, "Mode Updated successfully.")
      });
    }
  }
}
